export default "<div class='vs-slider'>\n  <ng5-slider [(value)]=\"value\" [options]=\"options\" (valueChange)=\"onSChange($event)\"></ng5-slider>\n</div>";